import React from 'react';
import '../style/mainContent.css'; // Estilos customizados

const MainContent = ({ children }) => {
  return (
    <div className="main-content" >
      {children}
    </div>
  );
};

export default MainContent;
